export function getSubdomain() {
  // Get the hostname
  const hostname = window.location.hostname;

  // Split the hostname into parts
  const parts = hostname.split('.');

  // Check if a subdomain is present
  if (parts.length > 1 || (parts.length === 1 && parts[1] !== 'localhost')) {
    return parts[0];
  }

  // No subdomain found
  return null;
}
